import axiosHttp from "./interceptor";

export const getPortCodes = async (portCodeQuery) => {
	try {
		const response = await axiosHttp.post(
			`api/PortCode/Query`,
			portCodeQuery
		);
		return response.data;
	} catch (error) {
		console.error(error);
	}
};

export const DeletePortCodeConfirmationForVesselOrVoyage = async (
	portCodeMstId
) => {
	try {
		const response = await axiosHttp.get(
			`api/PortCode/ValidatePortCodeDeletion?portCodeMstId=${portCodeMstId}`
		);
		return response.data;
	} catch (error) {
		console.error(error);
	}
};

export const DeletePortCodes = async (portCodeMstIds) => {
	try {
		const response = await axiosHttp.delete(
			`api/PortCode/DeletePortCodes`,
			{
				data: { portCodeMstIds },
			}
		);
		return response.data;
	} catch (error) {
		console.error(error);
	}
};

export const PostPortCode = async (portCodeForm) => {
	try {
		const response = await axiosHttp.post(
			`api/PortCode/AddPortCode`,
			portCodeForm
		);
		return response.data;
	} catch (error) {
		console.error(error);
	}
};

export const UpdatePortCode = async (portCodeForm, queryParam) => {
	try {
		const response = await axiosHttp.post(
			`api/PortCode/EditPortCode${queryParam}`,
			portCodeForm
		);
		return response.data;
	} catch (error) {
		console.error(error);
	}
};

export const getAllCountries = async (payLoad) => {
	try {
		const response = await axiosHttp.post(
			`api/MasterData/GetCountry`,
			payLoad
		);
		return response.data;
	} catch (error) {
		console.error(error);
	}
};

export const exportPortCodes = async () => {
	try {
		const response = await axiosHttp.get(`api/PortCode/Export`, {
			responseType: "arraybuffer", // or 'blob'
		});
		return response;
	} catch (error) {
		console.error(error);
	}
};
